import { ReactElement } from "react";
import styled from "styled-components";
import { Title } from "sunday-component";
import { color as COLOR } from "../../styles/globals";

type LabelProps = {
  readonly label: string;
  readonly textColor?: string;
  readonly backgroundColor?: string;
  // eslint-disable-next-line react/require-default-props
  readonly margin?: string;
};

const LabelContainer = styled.div<LabelProps>`
  width: fit-content;
  background: ${(props) => props.color || COLOR.frenchBlueFb};
  border-radius: 4px;
  align-self: center;
  margin: 0 8px 8px 0;
  padding: 4px 8px 4px 8px;
  ${(props) => (props.margin ? `margin: ${props.margin}` : "")}
  ${(props) => (props.margin ? `margin: ${props.margin}` : "")}
`;

const StyledTitle = styled(Title)`
  word-break: break-all;
  color: ${(props) => props.color || COLOR.white};
`;

const LabelBox = ({
  label,
  textColor, // HexCode
  backgroundColor, // HexCode
  margin,
}: LabelProps): ReactElement => (
  <LabelContainer label={label} margin={margin} color={backgroundColor}>
    <StyledTitle level={10} color={textColor}>
      {label}
    </StyledTitle>
  </LabelContainer>
);

LabelBox.defaultProps = {
  textColor: COLOR.white,
  backgroundColor: COLOR.frenchBlueFb,
};

export default LabelBox;
